export default __webpack_public_path__ + "static/media/Jack Frost.5dcfb77f.png";